import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../components/fields/file-input-field/FileInputField.vue";
import PermissaoEmissao from "./permissao-emissao/PermissaoEmissao.vue";
import { tipoPerfil } from "../../../constants";
import moment  from "moment";

//import { SnackBarModule } from "../../../modules/SnackBarModule";
import {
  EmitirRelatorioService
} from "../../../services/EmitirRelatorioService.js";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { FeriasService } from "../../../services/FeriasService";

export default {
  name: "EmitirRelatorio",

  components: {
    TextField,
    SelectField,
    AutocompleteField,
    PeriodoField,
    TextAreaField,
    FileInputField,
    PermissaoEmissao
  },

  beforeMount() {
    this.initializeForm();
    this.initializeOptions();
  },

  mounted() {
    this.getUnidadeItems();
  },


  data: () => ({
    showData: true,
    unidadeLotacao:null,
    lotacao:null,
    PermissaoEmissaoDialog: false,
    form: {},
    options: {},
    tipo: null,
    loading: {
      btn: false,
      field: false
    },
    optionsFilter: {
      unidade: [],
      lotacao: [],
    },
    filter: {
      dataInicio:null,
      dataTermino:null
    },
    disabledLotacao: true
  }),
  watch: {
    'tipo': function(tipo) {
      if (tipo == 'anuais/nao-agendada') {
        this.showData = false;
        this.filter.dataInicio = null;
        this.filter.dataTermino = null;
      } else {
        this.showData = true;
      }
    },
    'form.periodo': function(periodo) {
      if (periodo !== 'ano_mes') {
        this.form.ano = null;
        this.form.mes = null;
      }
    },
    'unidadeLotacao': function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
      }
    }
  },
  methods: {
    initializeForm() {
      this.form = {
        periodo: null,
        ano: null,
        mes: null
      }

    },
    initializeOptions() {
      this.options = {
        periodo: [{
            text: 'Diário',
            value: 'diario',
          },
          {
            text: 'Mensal',
            value: 'mensal',
          },
          {
            text: 'Semanal',
            value: 'semanal',
          },
          {
            text: 'Quinzenal',
            value: 'quinzenal',
          },
          {
            text: 'Bimestral',
            value: 'bimestral',
          },
          {
            text: 'Trimestral',
            value: 'trimestral',
          },
          {
            text: 'Quadrimestral',
            value: 'quadrimestral',
          },
          {
            text: 'Quimestral',
            value: 'quimestral',
          },
          {
            text: 'Semestral',
            value: 'semestral',
          },
          {
            text: 'Septumestral',
            value: 'septumestral',
          },
          {
            text: 'Octmestral',
            value: 'octmestral',
          },
          {
            text: 'Nonomestral',
            value: 'nonomestral',
          },
          {
            text: 'Anual',
            value: 'anual',
          },
          {
            text: 'Anual/Mensal (Ano e Mês)',
            value: 'ano_mes',
            description: 'Filtrar por ano e mês específicos',
          }
        ],
        anos: [ 
          { value: 2023, text: '2023' },
          { value: 2022, text: '2022' },
          { value: 2021, text: '2021' },
          { value: 2020, text: '2020' },
          { value: 2019, text: '2019' },
          { value: 2018, text: '2018' },
          { value: 2017, text: '2017' },
          { value: 2016, text: '2016' },
        ],
        meses: [
          { value: 1, text: 'Janeiro' },
          { value: 2, text: 'Fevereiro' },
          { value: 3, text: 'Março' },
          { value: 4, text: 'Abril' },
          { value: 5, text: 'Maio' },
          { value: 6, text: 'Junho' },
          { value: 7, text: 'Julho' },
          { value: 8, text: 'Agosto' },
          { value: 9, text: 'Setembro' },
          { value: 10, text: 'Outubro' },
          { value: 11, text: 'Novembro' },
          { value: 12, text: 'Dezembro' },
        ],
      }
    },

    prepareForm() {
      const formData = new FormData();

      const validaPeriodos = (this.filter.dataInicio == null && this.filter.dataTermino == null);

      if (this.tipo == null) {
        SnackBarModule('É necessário informar o tipo de relatório.', 'error')
        return;
      }

      if(typeof this.form.periodo != "string" && validaPeriodos){
        if(this.tipo != "anuais/nao-agendada"&& this.tipo != "anuais/vencer"){
          SnackBarModule('Campos obrigátorios não preenchidos', 'error')
          return;
        }
      }

      if (this.filter.dataInicio != null) {
        formData.append("periodo_inicio", this.filter.dataInicio);
      }

      if (this.filter.dataTermino != null) {
        formData.append("periodo_termino", this.filter.dataTermino);
      }

      if (this.filter.dataInicio != null && this.filter.dataTermino != null) {
        const dataInicio = moment(this.filter.dataInicio);
        const dataTermino = moment(this.filter.dataTermino);

        if (dataInicio.isAfter(dataTermino)) {
          SnackBarModule("O Período Data Inicial não pode ser maior que a Data Final:", 'warning');
          return;
        }
      }

      this.form.periodo ? formData.append('periodo',this.form.periodo) : null;

      if (this.form.ano && this.form.mes) {
        formData.append('ano', this.form.ano);
        formData.append('mes', this.form.mes);
      }

      if (this.unidadeLotacao) {
        formData.append('unidadeLotacao', this.unidadeLotacao);
      }

      if (this.unidadeLotacao) {
        formData.append('lotacao', this.lotacao);
      }
      
      this.saveForm(formData);
      return;
    },

    async saveForm(formData) {
      this.loading.btn = true;
      const response = await EmitirRelatorioService.emitirRelatorio(this.tipo, formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    async getUnidadeItems() {
      this.loading.field = true;

      const verificarUnidadeApoiadora = this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA');

      const response = await FeriasService.getUnidade(verificarUnidadeApoiadora);
      this.optionsFilter.unidade = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidade?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 

    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.lotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 

    verificarPermissaoDeEmissao(){
      const perfisUsuario = this.$store.state.user.Perfis;
      return perfisUsuario.indexOf(tipoPerfil['GERENCIA']) !== -1 || perfisUsuario.indexOf(tipoPerfil['ADMINISTRADOR_SISTEMA']) !== -1;
   },
  

    verificarPeriodo(){
      const permissao = this.tipo == 'anuais/vencer' ||  this.tipo == 'anuais/nao-agendada' ? false : true;

      if(!permissao){
        this.form.periodo = null;
      }
      return permissao
    },

    verificarExibirUnidadeLotacao() {
      const verificarUnidadeApoiadora = this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA');
      const verificarGerenteDHR = this.verificarSePerfilTemPermissao('GERENCIA');

      if (verificarGerenteDHR) {
        return true;
      }

      if (verificarUnidadeApoiadora) {
        return true;
      }

      return false;
    },

    verificarSePerfilTemPermissao(perfil){
      return this.$store.state.perfil_id == tipoPerfil[perfil];
    },

    close() {
      this.$emit('on-close');
    },

  },
};